











import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
/**
 * ポイントの初期化失敗時に表示するコンポーネント.
 */
export default class PointLoadError extends Vue {}
